export default __webpack_public_path__ + "19908ce5fb66a835d423c81546d97730.gif";